define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/Request",
	"csi/form/Widget",
	"csi/xml"
], function(declare,lang,csi,def,Field,Relationship,Request,Widget,xml) {

	return declare(Widget, {
		onChangeCategory: function(/*csi.form.View*/defView, /*Field*/field, /*Any*/value) {
			// summary: make sure to query for category to support currency expression
			this.cacheView.getNode(value, true);
		},

		_resolveView: function() {
			// summary: insert field if creating market outside the context of the business category
			var formNode = this.getFormNode();
			if (formNode && !xml.isValidURL(formNode.__Parent__)) {
				this.insertField(lang.mixin(new Field(), {
					bForceEditable: true,
					idParameter: "ParentURL",
					m_bRequired: true,
					m_id: xml.ATTR_PARENT,
					m_onChange: "onChangeCategory",
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: "BusinessCategory"
					}),
					m_request: lang.mixin(new Request(), {
						m_module: "BusinessPlanning",
						m_operation: "BusinessCategoryAddBusinessMarket"
					})
				}), 0);
			}

			this.addValueExpression("MarketCurrency", "childAttr('__Parent__.BusinessCurrency')");
			this.inherited(arguments);
		}
	});
});